/*
 * @Author: qiuwenjing qiuwenjing@vip56.cn
 * @Date: 2024-04-17 15:05:34
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2024-07-10 10:21:21
 * @FilePath: \projectManagementFrontd:\project\app\PosWholesaleClothing-Front\src\common\util\tail.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * 去尾法
 */
export function tailFun(val,num:number=2) {
  // console.log('val',val,num);
  
  let str = "";
  val = Number(val);
  if(val.toString().indexOf('.')>-1){
    let pos = val.toString().indexOf('.');
    str  = val.toString().slice(0,pos+num+1);
  }else{
    str =val+'.0'
  }
  return str;
}

export default {
  tailFun
};



// WEBPACK FOOTER //
// ./src/common/util/tailPad.ts